<div class="process-page">
  <header class="page-hero">
    <h1>Un proceso claro para tomar decisiones con confianza.</h1>
    <p class="hero-lead">
      Ordenamos el proyecto desde el problema inicial hasta la puesta en marcha, explicando qué se
      está valorando y cuál es el siguiente paso.
    </p>
    <a class="button button-primary" routerLink="/contacto">Cuéntanos tu proyecto</a>
  </header>

  <section class="principles" aria-labelledby="principles-title">
    <div class="section-heading">
      <h2 id="principles-title">Primero entendemos. Después proponemos.</h2>
    </div>
    <div class="principles-copy">
      <p>
        No hace falta llegar con una solución técnica decidida. La primera tarea es comprender el
        contexto de la empresa, el problema y el resultado que se busca.
      </p>
      <p>
        Con esa base se puede ordenar el alcance y preparar una propuesta proporcionada. Los plazos,
        revisiones y entregas concretas se definen para cada proyecto antes de comenzar.
      </p>
    </div>
  </section>

  <section aria-labelledby="stages-title">
    <div class="section-heading">
      <h2 id="stages-title">De una necesidad abierta a un proyecto entendible.</h2>
      <p>La secuencia sirve para reducir incertidumbre y evitar decisiones técnicas prematuras.</p>
    </div>
    <ol class="stage-list">
      <li>
        <span class="stage-number">01</span>
        <div class="stage-content">
          <h3>Conocer el contexto</h3>
          <p>
            Hablamos sobre la empresa, la situación actual, las personas implicadas y el objetivo
            que debería cumplir la solución.
          </p>
        </div>
        <p class="stage-result">
          <strong>Resultado:</strong> una necesidad expresada con claridad.
        </p>
      </li>
      <li>
        <span class="stage-number">02</span>
        <div class="stage-content">
          <h3>Ordenar necesidades y prioridades</h3>
          <p>
            Separamos lo imprescindible de lo que puede esperar y revisamos las condiciones que
            pueden afectar al proyecto.
          </p>
        </div>
        <p class="stage-result"><strong>Resultado:</strong> prioridades que se pueden valorar.</p>
      </li>
      <li>
        <span class="stage-number">03</span>
        <div class="stage-content">
          <h3>Definir la propuesta</h3>
          <p>
            Planteamos una solución, su alcance y las condiciones específicas del trabajo para que
            puedan revisarse antes de tomar una decisión.
          </p>
        </div>
        <p class="stage-result">
          <strong>Resultado:</strong> una propuesta concreta para el proyecto.
        </p>
      </li>
      <li>
        <span class="stage-number">04</span>
        <div class="stage-content">
          <h3>Desarrollar y revisar</h3>
          <p>
            Construimos la solución y compartimos avances en los puntos acordados. Las revisiones se
            realizan sobre criterios y alcance definidos previamente.
          </p>
        </div>
        <p class="stage-result">
          <strong>Resultado:</strong> una solución revisada dentro de su alcance.
        </p>
      </li>
      <li>
        <span class="stage-number">05</span>
        <div class="stage-content">
          <h3>Preparar la puesta en marcha</h3>
          <p>
            Comprobamos los elementos previstos para la entrega y aclaramos la gestión posterior que
            corresponda al servicio contratado.
          </p>
        </div>
        <p class="stage-result">
          <strong>Resultado:</strong> próximos pasos y responsabilidades claros.
        </p>
      </li>
    </ol>
  </section>

  <section class="collaboration" aria-labelledby="collaboration-title">
    <div class="section-heading">
      <h2 id="collaboration-title">Qué necesitamos de cada parte.</h2>
      <p>
        Un proyecto avanza mejor cuando la información y las decisiones tienen responsables claros.
      </p>
    </div>
    <div class="responsibility-grid">
      <article>
        <span>ATSIestudio</span>
        <h3>Ordenar y hacer comprensible la parte técnica.</h3>
        <ul>
          <li>Analizar la necesidad y señalar dudas o riesgos.</li>
          <li>Explicar la propuesta y las decisiones relevantes.</li>
          <li>Desarrollar y revisar según el alcance acordado.</li>
        </ul>
      </article>
      <article>
        <span>La empresa</span>
        <h3>Aportar contexto y validar las decisiones del negocio.</h3>
        <ul>
          <li>Facilitar información y materiales necesarios.</li>
          <li>Designar a las personas que tomarán decisiones.</li>
          <li>Revisar y responder en los puntos acordados.</li>
        </ul>
      </article>
    </div>
  </section>

  <section class="working-details" aria-labelledby="details-title">
    <div class="section-heading">
      <h2 id="details-title">Comunicación, revisiones y cambios sin zonas grises.</h2>
    </div>
    <dl>
      <div>
        <dt>Comunicación</dt>
        <dd>La propuesta concreta los interlocutores y los puntos de seguimiento necesarios.</dd>
      </div>
      <div>
        <dt>Revisiones</dt>
        <dd>Se acuerdan antes de empezar para que ambas partes sepan qué se revisa y cuándo.</dd>
      </div>
      <div>
        <dt>Cambios de alcance</dt>
        <dd>Una necesidad nueva se valora por separado antes de incorporarla al trabajo.</dd>
      </div>
      <div>
        <dt>Entrega y continuidad</dt>
        <dd>
          La entrega y el soporte posterior dependen del servicio y se detallan en la propuesta.
        </dd>
      </div>
    </dl>
  </section>

  <section class="process-cta" aria-labelledby="process-cta-title">
    <h2 id="process-cta-title">Empecemos por entender qué necesita tu empresa.</h2>
    <p>
      Cuéntanos el contexto, el problema o la idea. No necesitas preparar una especificación
      técnica.
    </p>
    <a class="button button-primary" routerLink="/contacto">Iniciar una conversación</a>
  </section>
</div>
